import React, { memo } from "react";

//import { useStore } from "src/store";

import { getClass, useDisabledBodyScroll } from "src/utils";
import { Icon } from "src/primitives";

import styles from "./style.css";
import { useHistory } from "react-router-dom";

export const Page = memo(props => {
  const { children, title, header, closeIcon, searchIcon, onClose, scrollToResults } = props;

  if (!scrollToResults) {
    useDisabledBodyScroll(window.location.pathname != "/");
  }

  return (
    <div class={styles.container + ' page__background'} id="page-cmp-container" >
        {header || (title ? <Page.Header title={title} closeIcon={closeIcon} searchIcon={searchIcon} onClose={onClose} /> : null)}
        {children}
    </div>
  );
});

Page.Header = memo(props => {
  const { children, title = "Page", closeIcon = "close", onClose } = props;
  const history = useHistory();

  const handleClick = () => {
    if (onClose) {
      onClose();
    } else {
      history.goBack();
    }
  }

  return (
    <header class={styles.header}>
      <span onClick={handleClick} class={getClass(styles.closeBtn, "skip-scroll-tracker")}>
         {closeIcon ? <Icon name={closeIcon} /> : null}
        </span>
      {children ? (
        <div class={styles.content}>{children}</div>
      ) : (
        <React.Fragment>
          <div>{title}</div>
          <span class={getClass(styles.searchBtn, "skip-scroll-tracker")}>
          </span>
        </React.Fragment>
      )}
    </header>
  );
});
